import { render, staticRenderFns } from "./block-document-logs.vue?vue&type=template&id=cb850162&scoped=true&lang=pug"
import script from "./block-document-logs.vue?vue&type=script&lang=js"
export * from "./block-document-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb850162",
  null
  
)

export default component.exports